export default "__VITE_ASSET__BMIuW756__"